import "core-js/modules/es6.object.assign";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Bookmark = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, Object.assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 100 100"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.312 13.111H31.687a3.007 3.007 0 00-3.007 3.007v68.557c0 1.224.992 2.215 2.216 2.215a2.2 2.2 0 001.509-.602h.014l16.094-16.094h.035c.355-.414.876-.682 1.465-.682s1.109.268 1.465.682h.035l15.918 15.918a2.2 2.2 0 001.673.777 2.216 2.216 0 002.216-2.215V16.118a3.007 3.007 0 00-3.008-3.007z"
  }));
});
Bookmark.displayName = 'Bookmark';
export var BookmarkDimensions = {
  height: 100,
  width: 100
};